export default "__VITE_ASSET__wB8bflie__"